import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// @mui
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------
// Renders the Markdown that admins write under Student Messages in the admin app.
// Keep in sync with the admin app's components/markdown/MessageMarkdown.js (its preview).

// Enter in the admin editor is a new line on the page; plain Markdown would join the lines
function remarkLineBreaks() {
  return (tree) => {
    const visit = (node) => {
      if (!node.children) return;
      node.children = node.children.flatMap((child) => {
        if (child.type !== 'text') {
          visit(child);
          return [child];
        }
        return child.value
          .split('\n')
          .flatMap((value, i) => (i ? [{ type: 'break' }, { type: 'text', value }] : [{ type: 'text', value }]));
      });
    };
    visit(tree);
  };
}

const StyledMessage = styled('div')(({ theme }) => ({
  '& p, & ul, & ol': { margin: 0, marginBottom: theme.spacing(2) },
  // The global styles strip list padding, which hides the bullets
  '& ul, & ol': { paddingLeft: theme.spacing(3) },
  '& li': { marginBottom: theme.spacing(0.5) },
  '& h1, & h2, & h3, & h4, & h5, & h6': { margin: 0, marginBottom: theme.spacing(1), fontSize: '1.125rem' },
  '& > :last-child': { marginBottom: 0 },
}));

const components = {
  a: ({ node, ...props }) => <Link target="_blank" rel="noopener" {...props} />,
};

MessageMarkdown.propTypes = {
  children: PropTypes.string,
  sx: PropTypes.object,
};

export default function MessageMarkdown({ children, sx }) {
  // Messages saved before the switch to Markdown used <br/> for line breaks.
  // Any other HTML is shown as text, never rendered.
  const markdown = (children || '').replace(/<br\s*\/?>/gi, '\n');

  return (
    <StyledMessage sx={sx}>
      <ReactMarkdown remarkPlugins={[[remarkGfm, { singleTilde: false }], remarkLineBreaks]} components={components}>
        {markdown}
      </ReactMarkdown>
    </StyledMessage>
  );
}
